var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('locker-nav',{attrs:{"lockerId":_vm.lockerId}}),_c('OrderListCommon',{attrs:{"locker-id":_vm.lockerId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }